import { AbstractEditEntityCommandStore } from "./AbstractEditEntityCommandStore";

export class EditEntityCommandStore<TSource, TEntity> extends AbstractEditEntityCommandStore<TSource, TEntity> {
  constructor(entity: TEntity | EditEntityCommandStore<TSource, TEntity>, toEntity: (s: TSource, e: TEntity) => TEntity) {
    super(entity);
    this._toEntity = (entity instanceof AbstractEditEntityCommandStore)
      ? entity._toEntity
      : toEntity;
  }

  private readonly _toEntity: (s: TSource, e: TEntity) => TEntity;

  protected toEntity(source: TSource, entity: TEntity): TEntity {
    return this._toEntity(source, entity);
  }
}
